/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.FileSystem')
    .directive('accSizeConverter', function() {
     var UNITS = {
         MEGABYTE: Math.pow(1024, 2),
         GIGABYTE: Math.pow(1024, 3)
     };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, attrs, ngModel) {
            var
                units = UNITS[attrs['accSizeConverter']],
                precision = parseInt(attrs['precision']) || 2;

            if(ngModel) { // Don't do anything unless we have a model
                ngModel.$parsers.push(function (value) {
                    if(value  == null) return null;
                    else return Math.round(value * units);
                });

                ngModel.$formatters.push(function (value) {
                    if(value  == null) return null;
                    else return Math.round(value / units * Math.pow(10, precision)) / Math.pow(10, precision);
                });

            }
        }
    };
});